export default {
    created: function () {},
    methods: {
        scrubName(name: string) {
            name = name.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, "");
            name = name.replace(/[^A-Za-z0-9 ]/g, "");
            return name;
        },
    },
};
